import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EmployerRoutingModule } from './employer-routing.module';
import { EmployerModuleComponent } from './employer.module.component';
import { EmployerLibraryModule, MaterialLibraryModule } from 'epay-library';
import { HelperLibraryModule } from 'epay-library';
import { CommonLibraryModule } from 'epay-library';
import { BaseLayoutModule } from '../layout/base-layout.module';
import { EMPHomeComponent } from './components/home/home.component';

import { EMPRegisterComponent } from './components/register/employer.register.component';
import { EMPACHDLandingComponent } from './components/achd/landing/achd.landing.component';
import { EMPEFTCreateFileComponent } from './components/eft/createfile/createfile.component';
import { EMPEFTInformationComponent } from './components/eft/information/eft-information.component';
import { EMPEFTLandingComponent } from './components/eft/landing/eft.landing.component';
import { EMPProfileComponent } from './components/profile/profile.component';
import { EMPACHDInformationComponent } from './components/achd/information/achd-information.component';
import { EMPPaymentComponent } from './components/achd/payment/payment.component';
import { EMPPaymentAccountListComponent } from './components/achd/paymentaccount/paymentaccountlist.component';
import { EMPSecondaryRegistrationComponent } from './components/register/secondary-registration/secondary-registration.component';
import { MatCardModule } from '@angular/material/card';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgxMaskModule } from 'ngx-mask';
import { MaskDataPipe } from 'epay-library';
import { EMPPaymentListComponent } from './components/achd/landing/emppayment-list/emppayment-list.component';
import { EpayCommonEmployerAchdHomeComponent } from './components/home/epay-common-employer-achd-home/epay-common-employer-achd-home.component';
import { EpayCommonEmployerPaymentActListComponent } from './components/achd/paymentaccount/epay-common-employer-payment-acct-list/epay-common-employer-payment-act-list.component';
import { EpayCommonNewPayAccountComponent } from './components/achd/paymentaccount/epay-common-employer-payment-acct-list/epay-common-new-pay-account/epay-common-new-pay-account.component';
import { EpayCommonEmpProfileAcctComponent } from './components/profile/epay-common-emp-profile-acct/epay-common-emp-profile-acct.component';

@NgModule({
  declarations: [
    EmployerModuleComponent,
    EMPHomeComponent,
    EMPRegisterComponent,
    EMPACHDLandingComponent,
    EMPEFTLandingComponent,
    EMPProfileComponent,
    EMPPaymentComponent,
    EMPPaymentAccountListComponent,
    EMPSecondaryRegistrationComponent,
    EMPACHDInformationComponent,
    EMPEFTInformationComponent,
    EMPEFTCreateFileComponent,
    EMPPaymentListComponent,
    EpayCommonEmployerAchdHomeComponent,
    EpayCommonEmployerPaymentActListComponent,
    EpayCommonNewPayAccountComponent,
    EpayCommonEmpProfileAcctComponent,
  ],
  imports: [
    CommonModule,
    EmployerRoutingModule,
    EmployerLibraryModule,
    HelperLibraryModule,
    CommonLibraryModule,
    BaseLayoutModule,
    MaterialLibraryModule,
    MatCardModule,
    MatTabsModule,
    MatTooltipModule,
    NgxMaskModule.forRoot(),
  ],
  providers: [MaskDataPipe],
})
export class EmployerModule {}
